<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="category_list" class="elevation-1 mytable" dense :search="search"
                :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Category</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="left" dense>
                        <v-col sm="3" md="3" cols="12"> </v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Category</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="category_super_master"
                                                        v-model.trim="addedItem.category_super_master"
                                                        item-text="name"
                                                        return-object
                                                        label="Select Category"
                                                        :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-text-field v-model.trim="editedItem.category" persistent-hint
                                                        :disabled="editedIndex != -1" :hint="editedIndex == -1
                                                                ? 'For example ::OBC, SC, NT '
                                                                : 'noneditable'
                                                            " label="Cast" :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field label="Category In Unicode" v-model="addedItem.category_super_master.unicode_name" v-if="editedIndex == -1"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field label="Category In Unicode" v-model="editedItem.unicode_category" v-if="editedIndex != -1"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model.trim="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model.trim="editedItem.is_caste_cert_compulsory"
                                                        color="success"
                                                        label="Is Caste Certificate Compulsory ?"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col v-if="editedIndex == -1">
                                                    <v-checkbox dense v-model.trim="newcheckbox" color="success"
                                                        label="Category not present in above list? Add new here..."></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12"
                                                    v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field v-model.trim="newcategory" persistent-hint
                                                        hint="For example :: EBC, NT, EWS, NT-3" label="New Category"
                                                        ref="newcategory"></v-text-field>
                                                </v-col>
                                                <v-col v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field label="New Category In Unicode" v-model="unicode_new_category"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="newcheckbox">
                                                    <v-btn class="mb-2 button" color="primary" small
                                                        @click="saveNewCategory">Save New
                                                        Category</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:item.is_caste_cert_compulsory="{ item }">
                    <span v-if="item.is_caste_cert_compulsory">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => (
        {

            valid: false,
            overlay: false,
            errorMsg: {
                category: false,
            },
            snackbar_msg: "",
            // extraBreadcrumbItems: [
            //     { text: "Category Master", disabled: true, href: "" },

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            search: "",

            dialog: false,
            newcategory: "",
            unicode_new_category:"",
            newcheckbox: false,
            category_super_master: [],
            headers: [
                {
                    text: "Category",
                    align: "left",
                    sortable: false,
                    value: "category",
                },
                {
                    text: "Category In Unicode",
                    align: "left",
                    sortable: false,
                    value: "unicode_category",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                {
                    text: "Is Caste Certificate Compulsory ?",
                    align: "left",
                    sortable: true,
                    value: "is_caste_cert_compulsory",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            category_list: [],
            editedIndex: -1,
            addedItem: {
                category_super_master: "",
            },
            editedItem: {
                id: "",
                category: "",
                unicode_category:"",
                isactive: true,
                is_caste_cert_compulsory: true
            },
            defaultItem: {
                id: "",
                category: "",
                unicode_category:"",
                isactive: true,
                is_caste_cert_compulsory: true
            },
        }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Category" : "Edit Category";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        hasWhiteSpace(s) {
            var status = false;
            var reWhiteSpace = new RegExp(/^\s+$/);

            // Check for white space
            if (reWhiteSpace.test(s)) {
                // alert("Please Check Your Fields For Spaces");
                return true;
            }
            return false;
        },
        saveNewCategory() {
            if (this.newcategory == null || this.newcategory == "") {
                if (this.hasWhiteSpace(this.newcategory))
                    this.showSnackbar("#b71c1c", "Please add Category!");
                this.$refs["newcategory"].focus();
                return;
            }
            let data = {
                newcategory: this.newcategory,
            };
            this.overlay = true;
            axios
                .post("/AdmissionMaster/addNewCategory", data)
                .then((res) => {
                    (this.newcategory = ""), (this.newcheckbox = false), (this.overlay = false);
                    if (res.data.status.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Category Added Successfully!!!"); // show snackbar on success
                        this.onLoad();
                    } else if (res.data.status.code == "NA") {
                        this.showSnackbar("#b71c1c", "Category Already Present!"); // show snackbar on error
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
            this.close();
        },

        editItem(item) {
            this.editedIndex = this.category_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/AdmissionMaster/category")
                .then((res) => {
                    if (res.data.msg == "200") {
                        //window.alert(res.data.msg)

                        if ((this.load = true)) {
                            this.overlay = false;
                            this.category_list = res.data.category_list;
                            this.category_super_master = res.data.category_super_master;
                        }
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
            this.newcheckbox = false;
            this.newcategory = "";
            this.unicode_new_category="";
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/AdmissionMaster/editCategory", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                //window.alert(res.data.msg)
                                Object.assign(this.category_list[this.editedIndex], this.editedItem);
                            }
                            this.showSnackbar("#4caf50", "Category Updated Successfully..."); // show snackbar on success
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                //this.category_list.push(this.editedItem)
                axios
                    .post("/AdmissionMaster/saveCategory", this.addedItem)
                    .then((res) => {
                        if (res.data.status.code == "SUCCESS") {
                            //window.alert(res.data.status.code)
                            this.category_list.push(this.addedItem);
                            this.showSnackbar("#4caf50", "Category Added Successfully!!!"); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.status.code == "NA") {
                            //window.alert(res.data.status.code)
                            this.showSnackbar("#b71c1c", "Category Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        }, //save()
        isValidated() {
            if (this.editedItem.category) {
                return true;
            } else {
                if (!this.editedItem.category) {
                    this.errorMsg.category = true;
                }

                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
